import { SelectionModel } from '@angular/cdk/collections';

export class ItemSelection<T> {
    private readonly model = new SelectionModel<number>(true);

    constructor(private readonly idOf: (item: T) => number) { }

    get ids(): number[] {
        return [...this.model.selected];
    }

    get count(): number {
        return this.model.selected.length;
    }

    hasValue(): boolean {
        return this.model.hasValue();
    }

    isSelected(item: T): boolean {
        return this.model.isSelected(this.idOf(item));
    }

    setSelected(item: T, selected: boolean): void {
        if (selected)
            this.model.select(this.idOf(item));
        else
            this.model.deselect(this.idOf(item));
    }

    isAllSelected(items: T[]): boolean {
        return items.length > 0 && items.every(item => this.isSelected(item));
    }

    isPartiallySelected(items: T[]): boolean {
        return items.some(item => this.isSelected(item)) && !this.isAllSelected(items);
    }

    setAllSelected(items: T[], selected: boolean): void {
        const ids = items.map(this.idOf);
        if (selected)
            this.model.select(...ids);
        else
            this.model.deselect(...ids);
    }

    retain(items: T[]): void {
        const keptIds = new Set(items.map(this.idOf));
        const droppedIds = this.model.selected.filter(id => !keptIds.has(id));
        if (droppedIds.length > 0)
            this.model.deselect(...droppedIds);
    }

    clear(): void {
        this.model.clear();
    }
}
